export default "__VITE_ASSET__zM2xz1PH__"